<template>
  <div>
    <v-toolbar flat outlined>
      <v-container fluid>
        <v-row align="center">
          <v-col>
            <v-toolbar-title class="font-weight-bold float-left">
              Laporan Mortalitas Jumlah Kematian Pasien
            </v-toolbar-title>
          </v-col>
          <v-spacer></v-spacer>
          <router-link to="/reporting/laporan-mortalitas">
            <v-btn color="grey" icon text>
              <v-icon>mdi-home </v-icon>
            </v-btn>
          </router-link>
          <v-btn color="grey" icon text @click="getPatientMortality(type)">
            <v-icon>mdi-autorenew </v-icon>
          </v-btn>
          <v-col cols="2">
            <v-autocomplete
              placeholder="Pilih Tahun"
              prepend-inner-icon="mdi-calendar-month"
              :items="yearRange"
              outlined
              dense
              hide-details="false"
              v-model="thisYear"
              @change="getPatientMortality(type)"
            />
          </v-col>
          <v-btn depressed color="primary" class="mx-0 text-none" tile disabled>
            Export
          </v-btn>
        </v-row>
      </v-container>
      <template v-slot:extension>
        <v-tabs v-model="tabs" centered slider-color="primary">
          <v-tab
            class="text-capitalize font-weight-bold"
            @click="
              type = 'oneYear';
              getPatientMortality('oneYear');
            "
          >
            Angka Kematian Dalam 1 Tahun
          </v-tab>
          <v-tab
            class="text-capitalize font-weight-bold"
            @click="
              type = 'fiveYears';
              getPatientMortality('fiveYears');
            "
          >
            Angka Kematian 5 Tahun Terakhir
          </v-tab>
        </v-tabs>
      </template>
    </v-toolbar>
    <v-main>
      <v-container>
        <v-tabs-items v-model="tabs">
          <v-tab-item>
            <v-row>
              <v-col cols="8">
                <v-card
                  color="#F0F9FF"
                  height="384"
                  flat
                  rounded="xl"
                  class="pa-3"
                >
                  <v-flex class="text-left px-3">
                    <h4>
                      Laporan Mortalitas Jumlah Kematian Pasien
                    </h4>
                    <label class="font-weight-medium caption grey--text">
                      Rata-rata angka laporan mortalitas jumlah kematian Pasien
                      di tahun {{ thisYear }}
                    </label>
                  </v-flex>
                  <!-- <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                    v-if="isLoading"
                  ></v-progress-circular> -->
                  <apexchart
                    ref="chartOneYear"
                    type="line"
                    height="320"
                    :options="pastOneYear.chartOptions"
                    :series="pastOneYear.series"
                  ></apexchart>
                </v-card>
                <h4 class="text-left py-2">Keterangan Warna</h4>
                <div class="text-left">
                  <v-btn
                    depressed
                    color="#975CFF"
                    width="200"
                    height="40"
                    class="text-none white--text body-2"
                    style="border-radius: 10px;"
                    >Pasien Meninggal <br />Death On Arrival (DOA)</v-btn
                  >
                  <v-btn
                    depressed
                    color="#F2994A"
                    height="40"
                    class="text-none white--text body-2 mx-2"
                    style="border-radius: 10px;"
                    >Pasien Meninggal &lt;48 jam</v-btn
                  >
                  <v-btn
                    depressed
                    color="#6CB2E2"
                    height="40"
                    class="text-none white--text body-2"
                    style="border-radius: 10px;"
                    >Pasien Meninggal &gt;48 jam</v-btn
                  >
                </div>
              </v-col>
              <v-col>
                <v-card color="#F0F9FF" flat rounded="lg" class="py-3">
                  <h5 class="text-left px-5 pb-2">
                    10 Diagnosa Penyebab Kematian Terbanyak
                  </h5>
                  <template v-for="(death, index) in pastOneYear.deathCause">
                    <v-divider :key="'divider-' + index"></v-divider>
                    <v-card-text
                      class="d-flex justify-space-between"
                      :key="'deathCause-' + index"
                    >
                      <span>{{ index + 1 }}</span>
                      <span class="text-left">{{ death.name }}</span>
                      <span class="">{{ death.count }} Pasien</span>
                    </v-card-text>
                  </template>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item>
            <v-row>
              <v-col cols="8">
                <v-card
                  color="#F0F9FF"
                  height="384"
                  flat
                  rounded="xl"
                  class="pa-3"
                >
                  <v-flex class="text-left px-3">
                    <h4>
                      Laporan Mortalitas Jumlah Kematian Pasien
                    </h4>
                    <label class="font-weight-medium caption grey--text">
                      Rata-rata angka laporan mortalitas jumlah kematian Pasien
                      di tahun 2020
                    </label>
                  </v-flex>
                  <!-- <v-progress-circular
                    :size="50"
                    color="primary"
                    indeterminate
                    v-if="isLoading"
                  ></v-progress-circular> -->
                  <apexchart
                    ref="chartFiveYear"
                    type="line"
                    height="320"
                    :options="pastFiveYear.chartOptions"
                    :series="pastFiveYear.series"
                  ></apexchart>
                </v-card>
                <h4 class="text-left py-2">Keterangan Warna</h4>
                <div class="text-left">
                  <v-btn
                    depressed
                    color="#975CFF"
                    width="200"
                    height="40"
                    class="text-none white--text body-2"
                    style="border-radius: 10px;"
                    >Pasien Meninggal <br />Death On Arrival (DOA)</v-btn
                  >
                  <v-btn
                    depressed
                    color="#F2994A"
                    height="40"
                    class="text-none white--text body-2 mx-2"
                    style="border-radius: 10px;"
                    >Pasien Meninggal &lt;48 jam</v-btn
                  >
                  <v-btn
                    depressed
                    color="#6CB2E2"
                    height="40"
                    class="text-none white--text body-2"
                    style="border-radius: 10px;"
                    >Pasien Meninggal &gt;48 jam</v-btn
                  >
                </div>
              </v-col>
              <v-col>
                <v-card color="#F0F9FF" flat rounded="lg" class="py-3">
                  <h5 class="text-left px-5 pb-2">
                    10 Diagnosa Penyebab Kematian Terbanyak
                  </h5>
                  <template v-for="(death, index) in pastFiveYear.deathCause">
                    <v-divider :key="'divider-' + index"></v-divider>
                    <v-card-text
                      class="d-flex justify-space-between"
                      :key="'deathCause-' + index"
                    >
                      <span>{{ index + 1 }}</span>
                      <span class="text-left">{{ death.name }}</span>
                      <span class="">{{ death.count }} Pasien</span>
                    </v-card-text>
                  </template>
                </v-card>
              </v-col>
            </v-row>
          </v-tab-item>
        </v-tabs-items>
      </v-container>
    </v-main>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import Constant from '@/const';

const axios = require('axios');

export default {
  name: 'PatientMortalityReport',
  components: {
    apexchart: VueApexCharts,
  },
  data() {
    return {
      date: null,
      menu: false,
      tabs: null,
      type: 'oneYear',
      thisYear: new Date().getFullYear(),
      pastOneYear: {
        series: [
          {
            name: 'Pasien Meninggal Death On Arrival (DOA)',
            data: [],
          },
          {
            name: 'Pasien Meninggal <48 jam',
            data: [],
          },
          {
            name: 'Pasien Meninggal >48 jam',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          xaxis: {
            categories: [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'Mei',
              'Jun',
              'Jul',
              'Ags',
              'Sep',
              'Okt',
              'Nov',
              'Des',
            ],
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'light',
              gradientToColors: ['#904CFF', '#F2994A', '#3498DB'],
              shadeIntensity: 1,
              type: 'vertical',
              opacityFrom: 1,
              opacityTo: 0.5,
              stops: [0],
            },
          },
          colors: ['#904CFF', '#F2994A', '#3498DB'],
          legend: {
            show: false,
          },
        },
        deathCause: [],
      },
      pastFiveYear: {
        series: [
          {
            name: 'Pasien Meninggal Death On Arrival (DOA)',
            data: [],
          },
          {
            name: 'Pasien Meninggal <48 jam',
            data: [],
          },
          {
            name: 'Pasien Meninggal >48 jam',
            data: [],
          },
        ],
        chartOptions: {
          chart: {
            height: 350,
            type: 'line',
            zoom: {
              enabled: false,
            },
          },
          dataLabels: {
            enabled: false,
          },
          stroke: {
            curve: 'smooth',
            width: 2,
          },
          xaxis: {
            categories: [],
          },
          fill: {
            type: 'gradient',
            gradient: {
              shade: 'light',
              gradientToColors: ['#904CFF', '#F2994A', '#3498DB'],
              shadeIntensity: 1,
              type: 'vertical',
              opacityFrom: 1,
              opacityTo: 0.5,
              stops: [0],
            },
          },
          colors: ['#904CFF', '#F2994A', '#3498DB'],
          legend: {
            show: false,
          },
        },
        deathCause: [],
      },
      isLoading: false,
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getPatientMortality('oneYear');
      this.getPatientMortality('fiveYears');
    });
  },
  computed: {
    yearRange() {
      let startYear = 1980;
      const currentYear = new Date().getFullYear();
      const years = [];
      while (startYear <= currentYear) {
        years.push(startYear++);
      }
      return years;
    },
  },
  methods: {
    getPatientMortality(type) {
      if (type === 'oneYear') {
        this.isLoading = true;
        axios
          .get(
            Constant.apiUrl.concat(
              `/report/mortalitas/patient?year=${this.thisYear}&isAnnual=1`,
            ),
          )
          .then(response => {
            const { doa, greater, less } = response.data.data.graph;
            this.$refs.chartOneYear.updateSeries(
              [
                {
                  name: 'Pasien Meninggal Death On Arrival (DOA)',
                  data: doa,
                },
                {
                  name: 'Pasien Meninggal <48 jam',
                  data: less,
                },
                {
                  name: 'Pasien Meninggal >48 jam',
                  data: greater,
                },
              ],
              false,
              true,
            );

            this.pastOneYear.deathCause = response.data.data.deathCause;
            this.isLoading = false;
          });
      } else {
        const today = new Date();
        const last_year = today.getFullYear();
        const first_year = last_year - 4;
        this.isLoading = true;

        for (let i = first_year; i <= last_year; i++) {
          this.pastFiveYear.chartOptions.xaxis.categories.push(i);
        }

        axios
          .get(
            Constant.apiUrl.concat(
              `/report/mortalitas/patient?year=${this.thisYear}&isAnnual=`,
            ),
          )
          .then(response => {
            const { doa, greater, less } = response.data.data.graph;
            this.$refs.chartFiveYear.updateSeries(
              [
                {
                  name: 'Pasien Meninggal Death On Arrival (DOA)',
                  data: doa,
                },
                {
                  name: 'Pasien Meninggal <48 jam',
                  data: less,
                },
                {
                  name: 'Pasien Meninggal >48 jam',
                  data: greater,
                },
              ],
              false,
              true,
            );

            this.pastFiveYear.deathCause = response.data.data.deathCause;
            this.isLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
